module.exports = __webpack_public_path__ + "static/media/proplus.2cd4f4c6.png";